import React from 'react'

const RightArrowIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="BiLeftArrowAlt">
                <path id="Vector" d="M11.2931 6.70697L15.5861 11L6.00006 11L6.00006 13L15.5861 13L11.2931 17.293L12.7071 18.707L19.4141 12L12.7071 5.29297L11.2931 6.70697Z" fill="white" />
            </g>
        </svg>
    )
}

export default RightArrowIcon;